import React from 'react';
import { BrandAnalyticsDashboard } from '@/components/brand/BrandAnalyticsDashboard';

// For now, use the same analytics dashboard for venture accounts
// Can be customized in the future with venture-specific terminology and metrics
export const VentureAnalyticsDashboard = () => {
  return <BrandAnalyticsDashboard />;
};
